import { ITagWithLabel } from '@tecalisdev/infinity';

/** Campo de paso FORM tal como vive en el FormArray del workflow (shape interno). */
export type FormStepFieldSnapshot = Record<string, unknown>;

/**
 * Etiquetas visibles en el listado de pasos FORM (Figma `9238:44360`).
 * Solo «Obligatorio» y «Cotejar» según validadores del paso; no tipos de campo.
 */
export function resolveFormStepListTags(
	fields: FormStepFieldSnapshot[],
	labels: { mandatory: string; matchOcr: string },
): ITagWithLabel[] {
	const tags: ITagWithLabel[] = [];
	let hasRequired = false;
	let hasMatchOcr = false;

	for (const field of fields) {
		const validators = (field['validators'] as string[] | undefined) ?? [];

		if (validators.includes('required')) {
			hasRequired = true;
		}

		if (field['match_ocr'] === true || validators.includes('match_ocr')) {
			hasMatchOcr = true;
		}
	}

	if (hasRequired) {
		tags.push({
			label: labels.mandatory,
			status: 'warning',
			size: 'sm',
		});
	}

	if (hasMatchOcr) {
		tags.push({
			label: labels.matchOcr,
			status: 'default',
			size: 'sm',
		});
	}

	return tags;
}

/** Firma estable para cachear etiquetas del listado según validadores de campos. */
export function formStepListTagsSignature(fields: FormStepFieldSnapshot[]): string {
	return JSON.stringify(fields.map((field) => [field['validators'], field['match_ocr']]));
}
